const Business = (props) => {
  const { size = "22", color = "#62748E" } = props;

  return (
    <svg
      width={size}
      height={size} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_802_9108)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.125 5.43567L9.375 1.68567V16.6857H4.125V5.43567Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.375 5.06067L14.625 8.81067V16.6857" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M1.5 16.6857H16.5" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_802_9108">
          <rect width={size} height={size} fill="white" transform="translate(0 0.185669)" />
        </clipPath>
      </defs>
    </svg>

  );
};

export default Business;
